import { Container, Grid } from 'semantic-ui-react';
import { Nav } from './Nav';
import { PageHeader } from '@common/PageHeader';
import { BPContainer } from '@/components/bp/bpcontainer';

interface LayoutProps {
    children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
    return (
        <BPContainer>
            <PageHeader header={'Manage your account'}></PageHeader>

            <Grid>
                <Grid.Column width={4}>
                    <Nav />
                </Grid.Column>
                <Grid.Column width={12}>
                    {children}
                </Grid.Column>
            </Grid>
        </BPContainer>
    );
};